import { BarChart3, Download, Link2, MousePointerClick } from 'lucide-react'
import OpenClawLandingPage from '../components/openclaw/OpenClawLandingPage'
import Ad2345DownloadButtons from '../components/openclaw/Ad2345DownloadButtons'

function OpenClawAd2345Display() {
  return (
    <OpenClawLandingPage
      theme="rose"
      productName="OpenClaw"
      showFriendLinks={false}
      seo={{
        title: 'OpenClaw 下载',
        description: 'OpenClaw 下载页，提供适用于不同系统版本的安装包下载入口。',
        keywords: 'OpenClaw下载, OpenClaw安装包, 官方下载'
      }}
      hero={{
        eyebrow: 'OpenClaw 下载',
        title: 'OpenClaw 下载',
        subtitle: '下载并开始使用 OpenClaw',
        description:
          '本页面提供 OpenClaw 不同系统版本的安装包下载入口，页面布局延续现有官方下载页风格，帮助用户快速选择对应版本并完成下载安装。\n下载安装完成后，可按客户端正常流程启动并登录使用。',
        tags: ['官方下载', '安装包下载', '多系统版本', '登录使用'],
        guideTitle: '下载、安装、登录即可开始使用',
        guideDescription: '根据设备系统选择对应版本下载安装包，完成安装后即可启动客户端并正常登录。',
        guideBullets: [
          '根据你的设备系统选择对应版本下载安装包。',
          '安装完成后打开客户端并完成登录。',
          '如果需要重新下载，不影响正常安装和使用。'
        ]
      }}
      screenshotCaption="该页面以官方下载体验为主，帮助用户快速完成版本选择和安装。"
      highlights={[
        {
          icon: MousePointerClick,
          title: '下载入口直达',
          description: '页面直接提供 3 个系统版本下载入口，降低用户进入页面后的决策成本。'
        },
        {
          icon: Download,
          title: '多系统版本覆盖',
          description: '支持 Windows、Mac Intel 和 Mac Apple 版本下载，满足常见桌面设备安装需求。'
        },
        {
          icon: BarChart3,
          title: '安装后即可使用',
          description: '下载安装后即可进入客户端并按原有流程登录使用，不需要额外操作。'
        }
      ]}
      steps={[
        {
          title: '进入下载页面',
          description: '用户进入页面后即可查看适合当前设备的安装包版本。'
        },
        {
          title: '选择系统版本下载',
          description: '根据设备系统点击对应下载按钮，浏览器开始下载目标安装包。'
        },
        {
          title: '完成安装',
          description: '下载完成后按系统提示安装客户端。'
        },
        {
          title: '启动并登录使用',
          description: '安装完成后打开客户端并登录，即可开始正常使用 OpenClaw。'
        }
      ]}
      sections={[
        {
          title: '页面布局保持一致',
          description:
            '本页面整体结构和现有下载承接页保持一致，便于在不同投放场景下快速复用，同时让用户获得熟悉的下载安装体验。',
          items: [
            '页面结构、模块顺序和视觉风格与现有下载页保持一致。',
            '下载区仍提供 3 个主要系统版本入口。',
            '不改动现有官网其他页面和原有下载链路。',
            '后续如需替换下载文件，只需调整对应文件映射。'
          ]
        },
        {
          title: '适合作为独立承接页',
          description: '该页面可作为单独推广入口存在，负责承接下载需求，并保持与官网现有体验风格统一。',
          items: [
            '入口清晰，适合独立投放使用。',
            '不会影响现有 /ad360 等页面逻辑。',
            '下载统计可单独按 ad2345 来源记录。',
            '后续如需扩展文案或补充说明，改动范围也较小。'
          ]
        }
      ]}
      faq={[
        {
          q: '这会影响现有下载页吗？',
          a: '不会。/ad2345 是新增独立页面，不会影响现有 /ad360 或官网其他下载页。'
        },
        {
          q: '如果重复下载，是否影响安装？',
          a: '不会。重复下载只会影响本地保存文件的次数，不影响正常安装和使用。'
        },
        {
          q: '下载后还需要额外配置吗？',
          a: '不需要。安装完成后直接启动客户端并按正常流程登录即可。'
        }
      ]}
      closing={{
        title: '选择系统版本并开始下载',
        description: '请直接选择你的系统版本下载安装包，完成安装后即可登录并开始使用 OpenClaw。',
        footerTitle: '独立下载入口，统计单独记录',
        footerDescription: '本页使用独立下载接口记录 ad2345 来源下载统计，不影响现有官网其他下载页面和承接链路。',
        footerTags: ['OpenClaw下载', '独立承接页', '多系统版本', '下载安装']
      }}
      downloadContent={<Ad2345DownloadButtons theme="rose" />}
    />
  )
}

export default OpenClawAd2345Display
